/*
 * @Author: liyifan 
 * @Date: 2025-05-15 16:00:04 
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-05-30 18:25:55
 * @description: 迁移 FAQ 组件
 */
import './index.less'
document.addEventListener('DOMContentLoaded', () => {
    // faq
    if (!customElements.get('product-faq-columns')) {
        customElements.define('product-faq-columns', class ProductFaq extends HTMLElement {
            constructor() {
                super()
                this.selectors = {
                    faq_columns: $(this).find(".produc-detail--faq-left"),
                    faq_columns_name: $(this).find(".produc-detail--faq-left .faq-category-name"),
                    faq_content: $(this).find(".produc-detail--faq-right ul[data-index]"),
                    faq_content_header: $(this).find(".produc-detail--faq-right ul[data-index] li .faq-header"),
                    more_btn: $(this).find(".faq--more")
                }
                this.init()
            }

            init() {
                const _this = this

                // FAQ 按分类展示
                if (this.selectors.faq_columns?.length > 0) {
                    this.selectors.faq_content.eq(0).find('.faq-header').eq(0).addClass("active")
                    this.selectors.faq_content.eq(0).find('.faq-content').eq(0).slideDown()

                    // faq分类 点击
                    this.columnClick()
                } else { // FAQ 不按分类展示
                    // 先收起全部
                    this.selectors.faq_content_header.each(function () {
                        $(this).next('.faq-content').slideUp()
                        $(this).removeClass("active")
                    })

                    // 默认展开第一个
                    this.selectors.faq_content.eq(0).find('.faq-header').eq(0).addClass("active")
                    this.selectors.faq_content.eq(0).find('.faq-content').eq(0).slideDown()
                }
                // faq header 点击
                this.selectors.faq_content_header.click(function () {
                    $(this).next('.faq-content').slideToggle()
                    $(this).toggleClass("active")

                    const activeElement = _this.selectors.faq_columns_name.filter(function () {
                        return $(this).hasClass("active");
                    });
                    // 数据埋码
                    gaPushDataLayer('section_FAQ_user_clicks', {
                        "module": "FAQ", // 固定名称FAQ
                        "position": _this.selectors.faq_columns?.length > 0 ? activeElement.text().trim() : null, // 左侧分类名称文本text。若无配置则无需识别。
                        "button_name": $(this).text().trim(), // 问题文本内容text
                        "type": $(this).hasClass("active") ? "open" : "fold", // 折叠fold，展开open。
                    })
                })

                // 跳转链接按钮 点击
                if (this.selectors.more_btn) {
                    if ((this.selectors.more_btn).attr('href') !== '') {
                        this.selectors.more_btn.css('display', 'block');
                    }
                    this.selectors.more_btn.click(function () {
                        const activeElement = _this.selectors.faq_columns_name?.filter(function () {
                            return $(this).hasClass("active");
                        });
                        // 数据埋码
                        gaPushDataLayer('section_FAQ_user_clicks', {
                            "module": "Parameter", // 固定名称Parameter
                            "position": activeElement?.text()?.trim() || null, // 左侧分类名称文本text。若无配置则无需识别。
                            "button_name": $(this)?.text()?.trim(), // 按钮名称文本text
                            "link": $(this).attr('href'), // 跳转链接
                        })
                    })
                }
            }
            columnClick() {
                const _this = this
                const columnsContainer = this.selectors.faq_columns.get(0)
                const len = this.selectors.faq_columns_name.length

                this.selectors.faq_columns_name.click(function () {
                    if ($(this).hasClass('active')) {
                        // 滚动到容器顶部
                        window.scrollTo({
                            top: _this.getElementTopPosition(),
                            behavior: "smooth"
                        })
                        return
                    }

                    $(this).addClass('active')
                    $(this).siblings().removeClass('active')

                    const index = $(this).data('index')
                    const viewMoreLink = $(this).data('view-more-link')

                    _this.selectors.faq_content.hide()
                    _this.selectors.faq_content.eq(index).show()

                    if (viewMoreLink) {
                        _this.selectors.more_btn.css("display", "block");
                        _this.selectors.more_btn.attr('href', viewMoreLink)
                    } else {
                        _this.selectors.more_btn.css('display', 'none')
                    }


                    // 计算目标元素相对于容器的偏移量，使其水平居中
                    const element = $(this).get(0)
                    const offsetLeft = element.offsetLeft - columnsContainer.offsetWidth / 2 + element.offsetWidth / 2;

                    // 使用 scrollLeft 平滑滚动
                    columnsContainer.scrollTo({
                        left: offsetLeft,
                        behavior: "smooth"
                    });

                    // 滚动到最后一个了，去掉 after 伪类
                    if (index === len - 1) {
                        columnsContainer.parentElement.classList.add('no-after')
                    } else {
                        columnsContainer.parentElement.classList.remove('no-after')
                    }

                    // 先收起全部
                    _this.selectors.faq_content_header.each(function () {
                        $(this).next('.faq-content').slideUp()
                        $(this).removeClass("active")
                    })

                    // 展开当前
                    _this.selectors.faq_content.eq(index).find('.faq-header').eq(0).addClass("active")
                    _this.selectors.faq_content.eq(index).find('.faq-content').eq(0).slideDown()

                    // 滚动到容器顶部
                    window.scrollTo({
                        top: _this.getElementTopPosition(),
                        behavior: "smooth"
                    })

                    // 数据埋码
                    gaPushDataLayer('section_FAQ_user_clicks', {
                        "module": "FAQ", // 固定名称FAQ
                        "position": $(this)?.text()?.trim(), // 左侧分类名称文本text。若无配置则无需识别。
                    })
                })
            }
            getElementTopPosition() {
                const rect = this.getBoundingClientRect()  // 获取元素相对于视口的位置
                const tabsH = document.querySelector('.product-tabs-container')?.getBoundingClientRect()?.height || 0
                return rect.top + window.scrollY - tabsH  // 元素距离页面顶部的高度
            }
        })
    }
})
